import { render, staticRenderFns } from "./AppNewVersionReloadPageTimer.vue?vue&type=template&id=610c9edc&scoped=true"
import script from "./AppNewVersionReloadPageTimer.vue?vue&type=script&lang=js"
export * from "./AppNewVersionReloadPageTimer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610c9edc",
  null
  
)

export default component.exports